/**
 * Schema of AuditValidation.schema
 */
import {datetime, Schema} from 'simpli-web-sdk'
import AuditValidation from '@/model/resource/AuditValidation'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import * as Helpers from '@/helpers'

export default (model: AuditValidation): Schema => ({
    idCargaFk: {
        content: model.idCargaFk ? model.idCargaFk : 0,
    },

    nroNotaFiscal: {
        textContent: model.nroNotaFiscal,
        content: model.nroNotaFiscal || '',
    },

    nroCte: {
        textContent: model.nroCte || '',
        content: model.nroCte || '',
    },

    danfe: {
        content: model.danfe || '',
        textContent: model.danfe || '',
    },

    entregador: {
        textContent: model.entregador || '',
        content: model.entregador || '',
    },

    placaVeiculo: {
        textContent: model.placaVeiculo || '',
        content: model.placaVeiculo || '',
    },

    transportador: {
        textContent: model.transportador || '',
        content: model.transportador || '',
    },

    enderecoEntrega: {
        textContent: model.enderecoEntrega ? model.enderecoEntrega.toString() : '',
        content: model.enderecoEntrega ? model.enderecoEntrega.toString() : '',
    },

    dataHoraCriacao: {
        content: model.dataHoraCriacao ? datetime(model.dataHoraCriacao) : '',
    },

    dataHoraBaixa: {
        content: model.dataHoraBaixa ? datetime(model.dataHoraBaixa) : '',
    },

    dataHoraEntrega: {
        content: model.dataHoraEntrega ? datetime(model.dataHoraEntrega) : '',
    },

    auditoria: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    value: model.auditoria && model.auditoriaStatus,
                    tagClass: model.auditoria && model.auditoriaStatusTagClass,
                },
            },
            {
                component: RenderLabelValue,
                props: {
                    value: model.auditoria && model.auditoriaStatus,
                    tagClass: model.auditoria && model.auditoriaStatusTagClass,
                },
            },
        ],
        textContent: model.auditoria && model.auditoriaStatus,
    },

    motivoAuditoria: {
        content: model.auditoria && model.auditoria.motivo && model.auditoria.motivo.nome || '',
        textContent: model.auditoria && model.auditoria.motivo && model.auditoria.motivo.nome || '',
    },

    statusNotificacaoAuditoria: {
        content: model.statusNotificacaoAuditoria && model.statusNotificacaoAuditoria.nome  || '',
        textContent: model.statusNotificacaoAuditoria && model.statusNotificacaoAuditoria.nome  || '',
    },

    dataCriacao: {
        content: model.auditoria && model.auditoria.dataCriacao && datetime(model.auditoria.dataCriacao) || '',
        textContent: model.auditoria && model.auditoria.dataCriacao && datetime(model.auditoria.dataCriacao) || '',
    },

    responsavelAuditoria: {
        content: model.auditoria && model.auditoria.responsavel && model.auditoria.responsavel.razaoSocial || '',
        textContent: model.auditoria && model.auditoria.responsavel && model.auditoria.responsavel.razaoSocial || '',
    },

    observacaoAuditoria: {
        textContent: model.observacaoAuditoria || '',
        content: model.observacaoAuditoria || '',
    },

    dataCanhoto: {
        content: model.auditoria && model.auditoria.dataCanhoto && datetime(model.auditoria.dataCanhoto) || '',
        textContent: model.auditoria && model.auditoria.dataCanhoto && datetime(model.auditoria.dataCanhoto) || '',
    },
})
